import React from 'react';

interface IconProps {
  fill: string;
  height: string;
  width: string;
}

function ZekiIcon({ fill, height, width }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 35 35">
      <path
        fill={fill}
        d="M29.83 5.088A17.18 17.18 0 0017.565 0C8.012 0 .227 7.783.218 17.338c0 3.06.8 6.038 2.312 8.674L.078 35l9.196-2.41a17.353 17.353 0 008.291 2.11h.009c9.555 0 17.338-7.783 17.347-17.347a17.277 17.277 0 00-5.093-12.265h.002zM17.565 31.765c-2.583 0-5.12-.695-7.341-2.013l-.525-.315-5.456 1.43L5.7 25.547l-.341-.55a14.35 14.35 0 01-2.203-7.666c0-7.932 6.468-14.403 14.418-14.403a14.35 14.35 0 0110.193 4.224 14.345 14.345 0 014.218 10.194c-.009 7.96-6.477 14.42-14.42 14.42zm7.908-10.793c-.431-.217-2.56-1.265-2.96-1.414-.398-.142-.689-.216-.973.217-.291.431-1.122 1.413-1.372 1.695-.25.291-.507.324-.94.11-.431-.219-1.83-.674-3.483-2.155-1.29-1.148-2.155-2.57-2.413-3.001-.25-.433-.024-.665.193-.882.19-.192.43-.507.647-.757.219-.249.291-.433.433-.722.143-.293.075-.542-.033-.758-.109-.217-.973-2.354-1.338-3.216-.35-.851-.707-.733-.974-.744-.25-.015-.54-.015-.83-.015a1.595 1.595 0 00-1.158.54c-.398.433-1.512 1.481-1.512 3.618 0 2.137 1.553 4.192 1.772 4.482.215.291 3.05 4.664 7.4 6.545 1.029.449 1.838.713 2.47.915 1.04.332 1.978.282 2.726.175.831-.127 2.561-1.05 2.927-2.063.358-1.015.358-1.881.25-2.063-.108-.184-.4-.29-.832-.507z"
      ></path>
    </svg>
  );
}

export default ZekiIcon;
